export function CheckIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="checkmark">
        <line
          fill="none"
          stroke="currentColor"
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"5px"}
          x1="3"
          x2="12"
          y1="16"
          y2="25"
        />
        <line
          fill="none"
          stroke="currentColor"
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          strokeWidth={"5px"}
          x1="12"
          x2="29"
          y1="25"
          y2="7"
        />
      </g>
    </svg>
  );
}
